"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation deleteStripeTerminalReader($readerId: String!) {
    deleteStripeTerminalReader(readerId: $readerId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteStripeTerminalReader.mutation.js.map